import { logWrapper } from '../../utils';

export default {
  onlyOfficeService: [
    'runtimeConstant',
    '$http',
    '$q',
    'webApiSettings',
    function (
      runtimeConstant,
      $http,
      $q,
      webApiSettings,
    ) {
      'use strict';

      function handleError(err, status) {
        //falhou
        if (status === 404 || status === -1) {
          var error = {
            status_code: status,
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            status_code: status,
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function pascalToCamel(obj) {
        if (Array.isArray(obj)) {
          return obj.map(pascalToCamel);
        } else if (obj !== null && typeof obj === 'object') {
          return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
              key.charAt(0).toLowerCase() + key.slice(1),
              pascalToCamel(value)
            ])
          );
        }
        return obj;
      }

      function getConfig(idRevision) {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}onlyoffice/config?key=${idRevision}`)
          .then(
            function (res) {
              const config = pascalToCamel(res.data);
              deferred.resolve(config);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          var onlyOfficeServiceFactory = {};

          onlyOfficeServiceFactory.getConfig = logWrapper(
            getConfig,
            runtimeConstant.isDebugServicesInternals
          );

          return onlyOfficeServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
